import { ActivityApi, StartPageTileApi } from "../openapi";
import openApiConfig from "./http_service";

const startTileApi=new StartPageTileApi(openApiConfig)

export default startTileApi